module.exports = __webpack_public_path__ + "img/icon-lotto-ac.35203ba0.png";